import { createFeature, createSelector } from '@ngrx/store';
import { reducer } from './user.reducer';

const EDITING_ROLES_UPPERCASE = ['COMCAST-XCA_ADMIN'].map(role =>
  role.toUpperCase(),
);

export const userFeature = createFeature({
  name: 'user',
  reducer,
  extraSelectors(baseSelectors) {
    const selectIsLoggedIn = createSelector(
      baseSelectors.selectUserState,
      ({ user }) => !!user,
    );
    const selectIsEditor = createSelector(
      baseSelectors.selectUserState,
      ({ user }) =>
        !!user?.roles?.some(role => {
          const uppercaseRole = role.toUpperCase();
          return EDITING_ROLES_UPPERCASE.includes(uppercaseRole);
        }),
    );
    return { selectIsLoggedIn, selectIsEditor };
  },
});

const {
  selectUserState,
  selectUser,
  selectReturnUrl,
  selectIsLoggedIn,
  selectIsEditor,
} = userFeature;
export const UserSelector = {
  selectUserState,
  selectUser,
  selectReturnUrl,
  selectIsLoggedIn,
  selectIsEditor,
};
